import { FaBookOpen, FaCalendarAlt, FaCreditCard, FaCertificate } from "react-icons/fa";

const steps = [
  {
    icon: <FaBookOpen className="text-blue-600 text-3xl" />,
    title: "1. Choose a Course",
    description: "Browse lifeguard, first aid, or instructor training that fits your goals."
  },
  {
    icon: <FaCalendarAlt className="text-blue-600 text-3xl" />,
    title: "2. View Schedule",
    description: "Check available dates, times, and locations before registering."
  },
  {
    icon: <FaCreditCard className="text-blue-600 text-3xl" />,
    title: "3. Register & Pay",
    description: "Sign up in minutes using our secure online form and payment system."
  },
  {
    icon: <FaCertificate className="text-blue-600 text-3xl" />,
    title: "4. Get Certified",
    description: "Complete training, pass the final assessment, and earn your certification!"
  }
];

const HowItWorks = () => (
  <section className="py-20 px-4 bg-white">
    <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">How It Works</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto text-center">
      {steps.map((step, index) => (
        <div key={index} className="p-6 bg-gray-50 rounded-xl shadow hover:shadow-md transition">
          <div className="mb-4">{step.icon}</div>
          <h3 className="text-lg font-semibold text-blue-900 mb-2">{step.title}</h3>
          <p className="text-sm text-gray-700">{step.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorks;
